import { Button, CircularProgress, DialogActions, Dialog, DialogTitle, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, DialogContent } from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import * as React from "react";
import { useContext, useState, useEffect } from "react";
import { DataUser } from "../../context/DataUser";
import { DataPM } from "../../context/DataPM";
import { uploadAudioForSegments } from "../../utils/audio/generateMix";
import { getActiveProjectsByPM } from "../../utils/project/CRUD";

const Modaladdcredits = ({ open, setOpen }) => {
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [descriptions, setDescriptions] = useState([]);

  const [selectedDescription, setSelectedDescription] = useState("");
  //console.log("selectedDescription",selectedDescription);
  const [segmentIds, setSegmentIds] = useState([]);
  //console.log("segmentIds",segmentIds);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [audioFile, setAudioFile] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const { user } = useContext(DataUser);
  const { getSegmentsByProjectsAndDescription } = useContext(DataPM);

  useEffect(() => {
    if (open && user) {
      fetchProjects();
    }
  }, [open, user]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const data = await getActiveProjectsByPM(user.uid);
      
      if (data.status) {
        setProjects(data.projects);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setToastMessage("Error fetching projects");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleProjectSelect = (projectId) => {
    setSelectedProjects((prev) => {
      if (prev.includes(projectId)) {
        return prev.filter((id) => id !== projectId);
      } else {
        return [...prev, projectId];
      }
    });
  };

  const handleSearchRepeated = async () => {
    if (selectedProjects.length < 2) {
      setToastMessage("Please select at least 2 projects");
      setToastSeverity("error");
      setOpenToast(true);
      return;
    }

    try {
      setLoading(true);
      const response = await getSegmentsByProjectsAndDescription(selectedProjects);
      //console.log("API Response:", response);
      if (response.status && response.segments) {
        // Los segmentos ya vienen con la estructura correcta
        setDescriptions(response.segments);
        
        if (response.segments.length === 0) {
          setToastMessage("No repeated segments found");
          setToastSeverity("info");
          setOpenToast(true);
        }
      }
    } catch (error) {
      //console.error("Error searching repeated segments:", error);
      setToastMessage("Error searching repeated segments");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleDescriptionSelect = async (description) => {
    setSelectedDescription(description);
    const selectedSegment = descriptions.find(seg => seg._id === description);
    if (selectedSegment && selectedSegment.segments) {
      const segmentIds = selectedSegment.segments.map(segment => segment._id);
      setSegmentIds(segmentIds);
      //console.log("Selected segment:", selectedSegment);
      //console.log("Segment IDs:", segmentIds);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProjects([]);
    setDescriptions([]);
    setSelectedDescription("");
    setSegmentIds([]);
    setAudioFile(null);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "audio/wav") {
      setAudioFile(file);
      setToastMessage("Audio file selected successfully");
      setToastSeverity("success");
      setOpenToast(true);
    } else {
      setToastMessage("Please select a valid WAV file");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };

  const handleConfirmUpload = async () => {
    try {
      setLoading(true);
      const result = await uploadAudioForSegments(audioFile, segmentIds);
      
      if (result.error) {
        setToastMessage(result.error);
        setToastSeverity("error");
      } else {
        setToastMessage(result.msg || "Audio uploaded successfully");
        setToastSeverity("success");
        setOpenConfirmModal(false);
        handleClose();
      }
    } catch (error) {
      console.error("Error uploading audio:", error);
      setToastMessage("Error uploading audio");
      setToastSeverity("error");
    } finally {
      setLoading(false);
      setOpenToast(true);
    }
  };

  return (
    <>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toastSeverity}>{toastMessage}</Alert>
      </Snackbar>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#28262E",
            color: "white"
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "white", backgroundColor: "#28262E" }}
        >
          Search Projects in Narration
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#28262E", padding: 3 }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div style={{ width: "100%", marginBottom: "20px" }}>
                <h3>Select Projects</h3>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {projects.map((project) => (
                    <Button
                      key={project._id}
                      variant={selectedProjects.includes(project._id) ? "contained" : "outlined"}
                      onClick={() => handleProjectSelect(project._id)}
                      sx={{ color: "white", borderColor: "white" }}
                    >
                      {project.name}
                    </Button>
                  ))}
                </div>
              </div>

              <Button
                onClick={handleSearchRepeated}
                disabled={selectedProjects.length < 2}
                sx={{ color: "white", backgroundColor: "#8EC36A", marginBottom: "20px" }}
              >
                Search Repeated Segments
              </Button>

              {descriptions.length > 0 && (
                <>
                  <FormControl fullWidth variant="outlined" sx={{ marginBottom: "20px" }}>
                    <InputLabel id="description-select-label" sx={{ color: 'white' }}>Select Description</InputLabel>
                    <Select
                      labelId="description-select-label"
                      id="description-select"
                      value={selectedDescription}
                      onChange={(e) => handleDescriptionSelect(e.target.value)}
                      label="Select Description"
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: '#28262E',
                            color: 'white'
                          }
                        }
                      }}
                      sx={{
                        color: 'white',
                        '.MuiOutlinedInput-notchedOutline': {
                          borderColor: 'white',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'white',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'white',
                        },
                        '.MuiSvgIcon-root': {
                          color: 'white',
                        }
                      }}
                    >
                      {descriptions.map((segment) => (
                        <MenuItem 
                          key={segment._id} 
                          value={segment._id}
                          sx={{
                            '&:hover': {
                              backgroundColor: '#3f3f3f'
                            },
                            '&.Mui-selected': {
                              backgroundColor: '#4a4a4a'
                            }
                          }}
                        >
                          {segment._id}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {selectedDescription && (
                    <div style={{ marginTop: "20px" }}>
                      <h3>Upload WAV Audio</h3>
                      <input
                        accept="audio/wav"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={handleFileChange}
                      />
                      <label htmlFor="raised-button-file">
                        <Button
                          variant="contained"
                          component="span"
                          startIcon={<CloudUploadIcon />}
                          sx={{
                            backgroundColor: '#8EC36A',
                            color: 'white',
                            '&:hover': {
                              backgroundColor: '#7ab358'
                            }
                          }}
                        >
                          Select WAV File
                        </Button>
                      </label>
                      {audioFile && (
                        <div style={{ marginTop: '10px', color: 'white' }}>
                          Selected file: {audioFile.name}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: "#28262E",
            padding: 3,
            display: "flex",
            justifyContent: "flex-end",
            gap: 2
          }}
        >
          <Button
            onClick={handleClose}
            sx={{ color: "white", backgroundColor: "#952937" }}
          >
            Cancel
          </Button>
          {selectedDescription && audioFile && (
            <Button
              onClick={() => setOpenConfirmModal(true)}
              sx={{ 
                color: "white", 
                backgroundColor: "#8EC36A",
                '&:hover': {
                  backgroundColor: '#7ab358'
                }
              }}
              startIcon={<CloudUploadIcon />}
              disabled={loading}
            >
              Upload
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        aria-labelledby="confirm-dialog-title"
        PaperProps={{
          sx: {
            backgroundColor: "#28262E",
            color: "white"
          }
        }}
      >
        <DialogTitle id="confirm-dialog-title" sx={{ color: "white" }}>
          Confirm Audio Upload
        </DialogTitle>
        <DialogContent sx={{ color: "white", pt: 2 }}>
          <div style={{ marginBottom: '15px' }}>
            This audio will be applied to all selected segments. Are you sure you want to proceed?
          </div>
          <div style={{ 
            backgroundColor: 'rgba(255,255,255,0.1)', 
            padding: '10px', 
            borderRadius: '4px',
            fontSize: '0.9em' 
          }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>File:</strong> {audioFile?.name}
            </div>
            <div>
              <strong>Selected segments:</strong> {segmentIds?.length || 0} segments
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#28262E", padding: 2 }}>
          <Button
            onClick={() => setOpenConfirmModal(false)}
            sx={{ color: "white", backgroundColor: "#952937" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmUpload}
            sx={{ 
              color: "white", 
              backgroundColor: "#8EC36A",
              '&:hover': {
                backgroundColor: '#7ab358'
              }
            }}
            disabled={loading}
          >
            Confirm Upload
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Modaladdcredits;